<template>
	<div class="custom-field-image">
		<!-- 上传按钮状态 -->
		<el-upload
			v-if="!imageUrl"
			action="#"
			:accept="formatUploadExt"
			:http-request="uploadFile"
			:show-file-list="false"
			:before-upload="beforeImageUpload"
			:disabled="uploading"
		>
			<el-link type="primary" :disabled="uploading" class="upload-link">
				<i v-if="uploading" class="el-icon-loading"></i>
				<span>{{ $t('enterprise.field.upload') }}</span>
			</el-link>
		</el-upload>

		<!-- 图片预览状态 -->
		<div v-else v-loading="uploading" class="image-preview-wrapper">
			<el-image :src="imageUrl" fit="cover" class="preview-image"></el-image>
			<!-- Hover 蒙层 -->
			<div class="image-mask">
				<el-upload
					action="#"
					:accept="formatUploadExt"
					:http-request="uploadFile"
					:show-file-list="false"
					:before-upload="beforeImageUpload"
					:disabled="uploading"
				>
					<el-button size="small" type="primary" plain>{{ $t('enterprise.field.reupload') }}</el-button>
				</el-upload>
				<el-button @click="onDeleteImage" size="small" type="danger" plain>{{ $t('enterprise.field.delete') }}</el-button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import { useImageUpload } from './useImageUpload';

const props = defineProps({
	field: {
		type: Object,
		required: true
	}
});

const emits = defineEmits(['update']);

const imageUrl = ref('');
const initImageUrl = () => {
	imageUrl.value = props.field?.dynamicFieldValue || '';
};
initImageUrl();

const onUploadFile = data => {
	const { viewurl = '' } = data || {};
	imageUrl.value = viewurl;
	emits('update', viewurl);
};

const onDeleteImage = () => {
	imageUrl.value = '';
	emits('update', '');
};

const { beforeImageUpload, uploadFile, formatUploadExt, uploading } = useImageUpload({
	limit: 5,
	onUpload: onUploadFile
});
</script>

<style lang="less" scoped>
.custom-field-image {
	.image-preview-wrapper {
		line-height: 1;
		font-size: 0;
		position: relative;
		display: inline-block;
		cursor: pointer;
		overflow: hidden;

		.preview-image {
			width: 160px;
			height: 90px;
		}

		.image-mask {
			position: absolute;
			top: -999px;
			left: 0;
			right: 0;
			bottom: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 0.5px solid #e5e6eb;
			background: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.4) 100%);
			opacity: 0;
			display: flex;
			flex-direction: column;
			gap: 12px;
		}
	}
	.image-preview-wrapper {
		&:hover {
			.image-mask {
				top: 0;
				opacity: 1;
			}
		}
	}

	.upload-link {
		display: inline-flex;
		align-items: center;
		gap: 6px;

		.el-icon-loading {
			font-size: 14px;
		}
	}

	/deep/ .el-link {
		vertical-align: baseline;
	}

	/deep/ .el-button {
		border: none !important;
		border-radius: 2px;
	}
}
</style>
